export enum TSocketChannelName {
  CARD_READER_CHANNEL = 'cardReaderChannel',
  PRINTER_STATE_CHANNEL = 'printerState',
  MONEY_ACCEPTORS_CHANNEL = 'moneyAcceptorsChannel',
  DEVICE_EVENTS_CHANNEL = 'deviceEvents',
}
